"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function loadDynamicScript(id, src) {
    return new Promise(function (resolve) {
        var existingScript = document.getElementById(id);
        if (!existingScript) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = src;
            script.id = id;
            document.body.appendChild(script);
            script.onload = function () {
                resolve();
            };
        }
        if (existingScript)
            resolve();
    });
}
exports.default = loadDynamicScript;
//# sourceMappingURL=loadDynamicScript.js.map